// extracted by mini-css-extract-plugin
module.exports = {"author-info-icon":"FollowButton_author-info-icon__Pnfqk","author-follow":"FollowButton_author-follow__FM9Cx","author-follow-text":"FollowButton_author-follow-text__wpdrE"};